import { useEffect, useState } from 'react';
import { useCommandCenter, selectKpis } from '../store';

function useClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return now;
}

export function KpiStrip() {
  const kpis = useCommandCenter(selectKpis);
  const connected = useCommandCenter((s) => s.connected);
  const now = useClock();

  return (
    <div className="flex h-[50px] items-center justify-between border-b border-cc-border bg-cc-surface px-4 font-mono text-xs uppercase tracking-wider text-cc-fg">
      <div className="flex items-center gap-6">
        <KpiItem label="Active" value={kpis.active} accent="ok" />
        <KpiItem label="Idle" value={kpis.idle} accent="warn" />
        <KpiItem label="Alerted" value={kpis.alerted} accent="crit" />
        <KpiItem label="Offline" value={kpis.offline} accent="muted" />
        <KpiItem label="Total" value={kpis.total} />
        <KpiItem label="Open Alerts" value={kpis.openAlerts} accent="crit" />
      </div>
      <div className="flex items-center gap-4">
        <span className="text-cc-muted">UTC {now.toISOString().slice(11, 19)}</span>
        <span className="tabular-nums">{now.toLocaleTimeString()}</span>
        <span
          className={`inline-flex items-center gap-1 ${connected ? 'text-cc-ok' : 'text-cc-crit'}`}
        >
          <span
            className={`inline-block h-2 w-2 rounded-full ${
              connected ? 'animate-pulse bg-cc-ok' : 'bg-cc-crit'
            }`}
          />
          {connected ? 'LIVE' : 'OFFLINE'}
        </span>
      </div>
    </div>
  );
}

function KpiItem({
  label,
  value,
  accent,
}: {
  label: string;
  value: number;
  accent?: 'ok' | 'warn' | 'crit' | 'muted';
}) {
  const tone =
    accent === 'ok'
      ? 'text-cc-ok'
      : accent === 'warn'
        ? 'text-cc-warn'
        : accent === 'crit'
          ? 'text-cc-crit'
          : accent === 'muted'
            ? 'text-cc-muted'
            : 'text-cc-fg';
  return (
    <div className="flex items-baseline gap-2">
      <span className="text-cc-muted">{label}</span>
      <span className={`text-base font-semibold tabular-nums ${tone}`}>{value}</span>
    </div>
  );
}
